import { getProject } from '../../common/services/project';
import { ITournament } from './typings';

export const getTournamentHref = (tournament: ITournament): string =>
  `#${getProject().url}/tournaments/${tournament.id}`;
